import {
  Stack, Typography
} from '@mui/material';

import { ReportFormat } from './index';

export const DefaultReportFormat: ReportFormat = {
  reportId: 'default',
  reportName: 'デフォルト',
  record: (props) => {
    const { sisetu, counter, count } = props;

    return (
      <Stack direction='column' component='div' style={{ pageBreakAfter: (counter < (count-1)) ? 'always' : 'auto' }}>
        <Stack direction='row' spacing={1} padding={1} alignItems='flex-end' borderBottom='3px solid #ad0026'>
          <Typography variant='h4' color='text.primary' component="div" whiteSpace='nowrap'>{sisetu.sisetuName}</Typography>
        </Stack>
      </Stack>
    );
  }
};
